import { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ProForm from './ProForm.container';
import { Modal } from '../../../../common/components';

class ProFormModal extends Component {
  static propTypes = {
    isMobileDevice: PropTypes.bool.isRequired,
    proJobType: PropTypes.string,
    t: PropTypes.func.isRequired,
    toggleProForm: PropTypes.func,
  };

  static defaultProps = {
    proJobType: '依頼',
    toggleProForm: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { proJobType, toggleProForm, isMobileDevice, t } = this.props;

    return (
      <section className="pro-form" data-test-id="pro-form">
        <Modal
          width="88%"
          maxWidth="30rem"
          height="288px"
          color="transparent"
          restrictClose={false}
          showCloseButton={true}
          closeButtonColor="black"
          onDismiss={() => toggleProForm(false)}
          isFullScreen={!isMobileDevice}
          testId="pro-form-modal"
        >
          <ProForm
            t={t}
            isMobileDevice={isMobileDevice}
            isDesktopHidden={true}
            proJobType={proJobType}
            toggleProForm={(show) => toggleProForm(show)}
          />
        </Modal>

        <style jsx>
          {`
            .pro-form {
            }
          `}
        </style>
      </section>
    );
  }
}

export default withTranslation()(ProFormModal);
